import { render, staticRenderFns } from "./text-display.vue?vue&type=template&id=24f4a08c&scoped=true"
import script from "./text-display.vue?vue&type=script&lang=js"
export * from "./text-display.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f4a08c",
  null
  
)

export default component.exports